import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DefaultView } from '../../../utils/userSettings';
import {
  IWindowSize,
  IUserSettings,
  initialUserSettingsSliceState,
  IQuickAccessDictionarySetting,
  SidebarState,
} from './types';

export default createSlice({
  name: 'userSettings',
  initialState: initialUserSettingsSliceState,
  reducers: {
    // not a part of user settings saved to kobol
    setWindowSize: (state, action: PayloadAction<IWindowSize>) => {
      state.windowSize = action.payload;
    },
    populateUserSettings: (_, action: PayloadAction<IUserSettings>) => {
      return action.payload;
    },
    setJupyterHost: (state, action: PayloadAction<string>) => {
      state.jupyterHost = action.payload;
    },
    setSidebarState: (state, action: PayloadAction<SidebarState>) => {
      state.sidebarState.sidebarState = action.payload;
    },
    setQuickAccessDictionarySetting: (
      state,
      action: PayloadAction<IQuickAccessDictionarySetting>,
    ) => {
      state.sidebarState.quickAccessDictionary = action.payload;
    },
    setDashboardSidebarSetting: (state, action: PayloadAction<any>) => {
      state.dashboardSidebarSetting = action.payload;
    },
    setExecutionHistorySidebarCollapsed: (
      draft,
      action: PayloadAction<boolean>,
    ) => {
      draft.isExecutionHistorySidebarExpanded = action.payload;
    },
    setDefaultSchemaId: (draft, action: PayloadAction<string>) => {
      draft.defaultSchemaId = action.payload;
    },
    setDefaultView: (draft, action: PayloadAction<DefaultView>) => {
      draft.defaultView = action.payload;
    },
    setActiveSchemaId: (draft, action: PayloadAction<string>) => {
      draft.activeSchemaId = action.payload;
    },
    setColorSchema: (draft, action: PayloadAction<string>) => {
      draft.colorSchemaSetting = action.payload;
    },
  },
});
